import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-y border-acad-line bg-acad-sand/55 px-4 py-20 sm:py-28" data-id="element-42" data-mp="1hbgtc9p1fr26">
      <div className="mx-auto max-w-3xl" data-id="element-43" data-mp="1cgb9dgf74mgq">
        <div className="text-center" data-id="element-44" data-mp="2a1ytb1ugtcbd">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-45" data-mp="2a0xkl40x91wt">
            Everything you need to know
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-46" data-mp="251b14cui2pfk">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="mt-12 space-y-3" data-id="element-47" data-mp="1v4g6i51cl96k">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-acad-line bg-white" data-id="element-48" data-mp="jq2mjb9ptdvt" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-acad-gold/25" data-id="element-49" data-mp="1koi11r5k1jar">
                  <span className="text-base font-semibold text-acad-ink" data-id="element-50" data-mp="11wz0rs2x0jcf">
                    {faq.question}
                  </span>
                  <ChevronDownIcon size={20} aria-hidden="true" className={`shrink-0 text-acad-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="16pihuz0t9wlz" />
                </button>
                <AnimatePresence initial={false} data-id="element-52" data-mp="izfsiqoa74r2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-53" data-mp="n07z1c5rqvjn">
                      <p className="border-t border-acad-line px-6 py-5 text-sm leading-6 text-acad-muted" data-id="element-54" data-mp="33lwgcixu41xs">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}